import { render, staticRenderFns } from "./QuotationSummary.vue?vue&type=template&id=2f4bc927&scoped=true"
import script from "./QuotationSummary.vue?vue&type=script&lang=js"
export * from "./QuotationSummary.vue?vue&type=script&lang=js"
import style0 from "./QuotationSummary.vue?vue&type=style&index=0&id=2f4bc927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4bc927",
  null
  
)

export default component.exports